import React, { useMemo } from "react";
import Invoice from "../components/Invoice";
import { getDateString } from "../../utils/dateutils";

function buildBillingRows(invoice) {
  return [
    {
      serviceName: "Monthly Service Fee per PDV User",
      total: invoice.pricePerVolunteer,
    },
    {
      serviceName: "PDV Users Submitting Forms",
      quantity: invoice.activeVolunteerCount,
    },
  ];
}

/**
 * Maps API / record `invoice` into props for the presentational `<Invoice />` component.
 */
function mapRecordToInvoiceData(invoice) {
  if (!invoice) return null;

  const billingRows = buildBillingRows(invoice);

  const currentCharges = invoice.currentCharges;
  const previousBalance = invoice.previousAccountBalance;
  const totalDue = invoice.totalAmountDue;
  const HVASubscriptionAmount = invoice.HVASubscriptionAmount;
  const HVASubscriptionExpiryDate = getDateString(invoice.HVASubscriptionExpiryDate);

  return {
    brandName: "Patient Data Vault",
    organizationName: invoice?.organizationName,
    accountNumber: invoice.accountNumber,
    address: invoice?.organizationCompleteAddress,
    invoiceNumber: invoice.invoiceId ?? "—",
    invoiceDate: invoice.invoiceDate ? getDateString(invoice.invoiceDate) : "—",
    dueDate: invoice.payByDate ? getDateString(invoice.payByDate) : "—",
    amountDue: totalDue,
    accountSummary: {
      currentCharges,
      previousBalance,
      totalDue,
      HVASubscriptionAmount,
      payByDate: getDateString(invoice.payByDate),
    },
    billingPeriod: `${getDateString(invoice.billingPeriodStart)} - ${getDateString(invoice.billingPeriodEnd)}`,
    billingRows,
    billingSubtotal: invoice.currentCharges,
    codingNumber: invoice?.codingNumber,
    HVASubscriptionExpiryDate,
  };
}

/**
 * Read-only invoice for modal / PDF. Renders the modern `<Invoice />` layout.
 */
const InvoiceViewContent = ({ invoice }) => {
  const data = useMemo(() => mapRecordToInvoiceData(invoice), [invoice]);

  if (!invoice || !data) {
    return (
      <div className="billing-empty-state">
        <p className="text-muted">Invoice not found.</p>
      </div>
    );
  }

  return <Invoice data={data} embedded />;
};

export default InvoiceViewContent;
